import { gql } from '@/shared/graphql/generated/explorer';

export const getCurrentEpochQuery = gql(/* GraphQL */ `
  query GetLatestAuthoritySet {
    currentAuthoritySet: allAuthorityMemberships(orderBy: EPOCH_ID_DESC, first: 1) {
      nodes {
        epochId
      }
    }
  }
`);

export const getFundedAccountsByFunderQuery = gql(/* GraphQL */ `
  query GetFundedAccountIdsByFunder($walletAddress: String!) {
    events: allAccountFundingEvents(
      filter: { fundedFunder: { equalToInsensitive: $walletAddress }, type: { equalTo: FUNDED } }
    ) {
      nodes {
        accountId
        account: accountByAccountId {
          idSs58
        }
      }
    }
  }
`);

export const getRedemptionsByAccountIdsQuery = gql(/* GraphQL */ `
  query GetRedemptionsByAccountIds($accountIds: [Int!]!) {
    events: allAccountFundingEvents(
      filter: { type: { equalTo: REDEEMED }, accountId: { in: $accountIds } }
    ) {
      nodes {
        ...RedeemedEvent
      }
    }
  }
`);

export const getAccountsRewardsQuery = gql(/* GraphQL */ `
  query GetAccountsRewards($idSs58s: [String!]!, $epochId: Int!) {
    accounts: allAccounts(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
        validator: validatorByAccountId {
          historicRewards: authorityMembershipsByValidatorId(
            filter: { epochId: { notEqualTo: $epochId } }
          ) {
            aggregates {
              sum {
                reward
              }
            }
          }
          currentRewards: authorityMembershipsByValidatorId(
            filter: { epochId: { equalTo: $epochId } }
          ) {
            aggregates {
              sum {
                reward
              }
            }
          }
        }
      }
    }
  }
`);

export const getAccountsSlashedQuery = gql(/* GraphQL */ `
  query GetAccountsSlashed($idSs58s: [String!], $epochId: Int) {
    accounts: allAccounts(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
        slashedEvents: accountFundingEventsByAccountId(filter: { type: { equalTo: SLASHED } }) {
          aggregates {
            sum {
              amount
            }
          }
        }
        currentEpochslashedEvents: accountFundingEventsByAccountId(
          filter: { and: [{ type: { equalTo: SLASHED } }, { epochId: { equalTo: $epochId } }] }
        ) {
          aggregates {
            sum {
              amount
            }
          }
        }
      }
    }
  }
`);

export const getAccountFundingDatesByIdSs58Query = gql(/* GraphQL */ `
  query GetAllValidatorFundingDates($idSs58s: [String!]!) {
    accounts: allAccounts(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
        firstFunding: accountFundingEventsByAccountId(
          orderBy: ID_ASC
          first: 1
          filter: { type: { in: [FUNDED, FUNDED_ON_CHAIN] } }
        ) {
          nodes {
            event: eventByEventId {
              block: blockByBlockId {
                timestamp
                id
              }
            }
          }
        }
        latestFunding: accountFundingEventsByAccountId(
          orderBy: ID_DESC
          first: 1
          filter: { type: { in: [FUNDED, FUNDED_ON_CHAIN] } }
        ) {
          nodes {
            event: eventByEventId {
              block: blockByBlockId {
                timestamp
                id
              }
            }
          }
        }
      }
    }
  }
`);

export const getValidatorCfeVersionQuery = gql(/* GraphQL */ `
  query GetValidatorCfeVersion($idSs58: String!) {
    account: accountByIdSs58(idSs58: $idSs58) {
      validator: validatorByAccountId {
        cfeVersionId
      }
    }
  }
`);

export const getValidatorProcessorIdsQuery = gql(/* GraphQL */ `
  query GetValidatorProcessorIds($idSs58: String!) {
    account: accountByIdSs58(idSs58: $idSs58) {
      id
      validator: validatorByAccountId {
        id
      }
    }
  }
`);

export const getValidatorsListDetailsQuery = gql(/* GraphQL */ `
  query GetValidatorsListDetails($idSs58s: [String!]!, $epochId: Int!) {
    accounts: allAccounts(condition: { role: VALIDATOR }, filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
        validator: validatorByAccountId {
          cfeVersionId
          authorityMemberships: authorityMembershipsByValidatorId {
            aggregates {
              sum {
                reward
                rewardValueUsd
              }
            }
          }
          currentEpochMembership: authorityMembershipsByValidatorId(
            condition: { epochId: $epochId }
          ) {
            nodes {
              reward
              rewardValueUsd
            }
          }
        }
      }
    }
  }
`);

export const getValidatorStatsQuery = gql(/* GraphQL */ `
  query GetValidatorStats($idSs58: String!) {
    account: accountByIdSs58(idSs58: $idSs58) {
      validator: validatorByAccountId {
        cfeVersionId
        rewards: authorityMembershipsByValidatorId {
          aggregates {
            sum {
              reward
              rewardValueUsd
            }
          }
        }
        latestMembership: authorityMembershipsByValidatorId(orderBy: EPOCH_ID_DESC, first: 1) {
          nodes {
            epochId
          }
        }
      }
    }
  }
`);
